export const Constants = {
    NONE_NAME : "None",
    NONE_GUID : "00000000-0000-0000-0000-000000000000",
    PRICING_POLICY_FIXED : "11111111-1111-1111-1111-111111111111"
}

export enum GstCode{
    F,
    N,
    Y,
}

export enum E_LoginChannels
{
    Browser,
    ZPocket,
    ZCore
}

export enum States {
    ALL = 0,
    NSW = 1,
    VIC = 2,
    QLD = 4,
    SA = 8,
    WA = 16,
    TAS = 32,
    NT = 64,
    ACT = 128,
}

export const ScheduleCodes: string[] = ['S2', 'S3', 'S3R', 'S4', 'S4D', 'S4DB', 'S6', 'S8', 'U',]


export function statesToString(states: States): string {
    if (states === States.ALL) {
        return "ALL";
    }

    return Object.entries(States)
        .filter(([key, value]) => typeof value === "number" && states & value)
        .map(([key]) => key)
        .join(", ");
}

export const PROMOTION_TYPES = [
    {
        label: "",
        value: -1
    },
    {
        /*XDollar*/
        label: "Buy X for $",
        value: 0
    },
    {
        /*XMorePercent*/
        label: "Buy X or more and get % off",
        value: 1
    },
    {
        /*XRangeDollar*/
        label: "Buy any X in range and get $ off",
        value: 2
    },
    {
        /*XMoreRangePercent*/
        label: "Buy any X or more in range and get % off",
        value: 3
    },
    {
        /*AdvancedPromotion*/
        label: "Advanced Promotion",
        value: 4
    }
]

export const STOCK_TEMPLATE_MATCH_TYPES = [
    {
        label: "ID",
        value: "ID"
    },
    {
        label: "APN Only",
        value: "APN"
    },
    {
        label: "PDE Only",
        value: "PDE"
    },
    {
        label: "APN and PDE",
        value: "APNPDE"
    }
]

export const STOCK_IMPORT_TYPES = [
    {
        label: "Create",
        value: "Create"
    },
    {
        label: "Update",
        value: "Update"
    }
]

export const STORELOAD_ENTITIES = [
    {
        label: "",
        value: -1
    },
    {
        label: "Stock",
        value: 0
    },
    {
        label: "Script",
        value: 1
    },
    {
        label: "Promotion",
        value: 2
    },
    {
        label: "Order",
        value: 3
    },
    {
        label: "Receipt Item",
        value: 4
    },
    {
        label: "Receipt Payment",
        value: 5
    }
]